<template>
    <div v-if="parameters.isShowMax && maxLength !== Infinity">
        <a-textarea
            v-model="changeValue"
            :autoSize="autoSize"
            :maxLength="maxLength"
            :clearable="parameters.clearable"
            :placeholder="parameters.placeholder"
            @blur="$emit('blurField')"
        >
        </a-textarea>
        <div style="text-align: right; line-height: 1.2; opacity: 0.6">
            {{ `${changeValue.length}/${maxLength}` }}
        </div>
    </div>
    <a-textarea
        v-else
        v-model="changeValue"
        :autoSize="autoSize"
        :maxLength="maxLength"
        :clearable="parameters.clearable"
        :placeholder="parameters.placeholder"
        @blur="$emit('blurField')"
    >
    </a-textarea>
</template>

<script>
import { DataEntryMixin } from './mixins';

export default {
    name: 'SdTextarea',
    mixins: [DataEntryMixin],
    computed: {
        // 是否可编辑
        isModify({ $props }){
            return Boolean($props.field.isModify);
        },
        autoSize({ parameters }) {
            return {
                minRows: parameters.minRows || 4,
                maxRows: parameters.maxRows || 6,
            };
        },
        suffixStyle() {
            return {
                position: 'absolute',
                right: '12px',
                bottom: '0',
                userSelect: 'none',
                opacity: 0.6,
            };
        },
        maxLength({ parameters }) {
            return parameters.maxLength || parameters.maxLength === 0
                ? parameters.maxLength < 512 || parameters.maxLength === 512
                    ? parameters.maxLength
                    : 512
                : Infinity;
        },
    },
};
</script>

<style scoped lang="less"></style>
